import { ReactNode } from 'react'
import useCalendly from '../../hooks/useCalendly';
interface CButtonI {
	children: ReactNode,
	className?: string
}

const CalendlyButton = ({ children, className }: CButtonI) => {
	const calendly = useCalendly();
	return (
		<span className={className} onClick={() => calendly.setCalendlyIsOpened(true)}>{children}</span>
	)
}

export default CalendlyButton